import { css } from '@emotion/css'
import { colors, fontWeight, shorthandHelper, spacing } from '@offerzen/pinata-shame'

const styles = {
  headingWrapper: css({
    '> *': {
      margin: shorthandHelper([0, 0, spacing.default]),
      color: colors.oxfordBlue,
      fontWeight: fontWeight.medium,

      '& ~ &': {
        marginTop: spacing.medium,
      },
    },
  }),
}

export default styles
